import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_APP_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorage, // Explicitly use localStorage for session persistence
    autoRefreshToken: true, // Automatically refresh sessions
    persistSession: true, // Persist session across browser sessions
    detectSessionInUrl: true, // Detect session in URL for OAuth flows
  },
});
